import { render, staticRenderFns } from "./StatPlatForm.vue?vue&type=template&id=164480d2&scoped=true&"
import script from "./StatPlatForm.vue?vue&type=script&lang=js&"
export * from "./StatPlatForm.vue?vue&type=script&lang=js&"
import style0 from "./StatPlatForm.vue?vue&type=style&index=0&id=164480d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164480d2",
  null
  
)

export default component.exports